module.exports = __webpack_public_path__ + "img/Check2.0231bba9.png";